import React, { useState } from "react";
import { imgSrc } from "./admin/imageUtils";

const ProductGallery = ({ product, dim }) => {
  const images = product.images?.length ? product.images : product.image ? [product.image] : [];
  const [idx, setIdx] = useState(0);
  return (
    <div className="h-full flex flex-col">
      <img src={imgSrc(images[idx]) || undefined} alt={`${product.name} ${product.variant}`} data-testid={`product-main-image-${product.id}`}
        className={`h-52 sm:h-auto sm:flex-1 w-full object-cover sm:min-h-[220px] ${dim ? "grayscale opacity-70" : ""}`} />
      {images.length > 1 && (
        <div className="flex gap-1.5 p-2 overflow-x-auto bg-white">
          {images.map((u, i) => (
            <button key={u} type="button" onClick={() => setIdx(i)} data-testid={`product-thumb-${product.id}-${i}`}
              className={`h-11 w-11 shrink-0 rounded-lg overflow-hidden border-2 transition-colors ${i === idx ? "border-[#f7941e]" : "border-transparent opacity-70 hover:opacity-100"}`}>
              <img src={imgSrc(u)} alt={`Bild ${i + 1}`} className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
